<template>
    <div class="w-full" :class="{ 'mt-1 relative rounded-md shadow-sm': isPhone }">
        <div v-if="isPhone" class="absolute inset-y-0 left-0 flex items-center">
            <label for="phone_country" class="sr-only">Country</label>
            <select v-model="phoneCountryCode" id="phone_country" name="country" class="pl-3 pr-7 py-0 h-full text-gray-500 bg-transparent focus:border-indigo-500 border-transparent rounded-md focus:ring-indigo-500 sm:text-sm">
                <option value="US">US</option>
                <!--                <option value="ca">CA</option>-->
                <!--                <option value="eu">EU</option>-->
            </select>
        </div>
        <input ref="input" :value="value" v-bind="$attrs" :type="type" class="block w-full border-gray-300 focus:border-indigo-500 rounded-md shadow-sm focus:ring-indigo-500 sm:text-sm dark:text-slate-600" :class="{ 'pl-16': isPhone }" @input="$emit('input', $event.target.value)" />
    </div>
</template>

<script>
export default {
    props: ["value", "type", "country-code"],

    computed: {
        phoneCountryCode: {
            get() {
                return this.countryCode ?? "US"
            },
            set(val) {
                this.$emit("update:countryCode", val)
            },
        },
        isPhone() {
            return this.type === "tel"
        },
    },

    data() {
        return {}
    },

    methods: {
        focus() {
            this.$refs.input.focus()
        },
    },
}
</script>
